module.exports = __webpack_public_path__ + "static/media/photo-slider-2.40800d27.png";